import React from 'react'
import {
  Collection,
  ExecuteOperationOnPipe,
  ForEachModel,
  TriggerPipelineOnFormSubmit,
  TriggerPipelineOnOperationExecute,
  WhenCollectionIsNotEmpty
} from '@morningtrain/react-resources'
import { StaticFilter } from '@morningtrain/react-filters'
import { SelectedDepartmentFilter } from 'support/filters'
import { AsyncPipeline } from '@morningtrain/react-pipelines'
import SetItemsInEnvOnPipe from 'pages/app/inventory/norms/SetItemsInEnvOnPipe'
import { useTranslation } from '@morningtrain/react-translations'
import { Switch } from '@morningtrain/react-fields'

export default function ForEachNormItemCategory ({ children }) {
  const placeholder = useTranslation('category_selector_placeholder')

  return (
    <Collection resourceName='inventory.norms' operationName='overview'>
      <StaticFilter name='withNorms' value />
      <SelectedDepartmentFilter />
      <AsyncPipeline>
        <TriggerPipelineOnFormSubmit />
        <ExecuteOperationOnPipe resourceName='inventory.norms' operationName='overview' />
      </AsyncPipeline>
      <AsyncPipeline>
        <TriggerPipelineOnOperationExecute />
        <SetItemsInEnvOnPipe />
      </AsyncPipeline>
      <WhenCollectionIsNotEmpty>
        <Switch optionsKey='key' placeholder={placeholder} className='w-44'>
          <ForEachModel>
            {children}
          </ForEachModel>
        </Switch>
      </WhenCollectionIsNotEmpty>
    </Collection>
  )
}
